
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { motion } from 'framer-motion';
import FireworkAnimation from '../components/join/FireworkAnimation';
import LoginForm from '../components/join/LoginForm';
import MultiStepRegistrationForm from '../components/registration/MultiStepRegistrationForm';

const JoinPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [showFireworks, setShowFireworks] = useState(false);
  
  // Redirect to community page if already logged in
  useEffect(() => {
    if (user) {
      navigate('/community');
    }
  }, [user, navigate]);

  useEffect(() => {
    // Show fireworks animation after a short delay when page loads
    const timer = setTimeout(() => {
      setShowFireworks(true);
      setTimeout(() => setShowFireworks(false), 3000); // Hide after 3 seconds
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bg-gray-950 min-h-screen bg-cover bg-no-repeat bg-center"
        style={{
          backgroundImage: 'url(/lovable-uploads/c991389f-c2d1-4e8c-aee1-419cb7b0f3f0.png)',
          backgroundSize: '100% auto',
          backgroundPosition: 'top center',
          backgroundAttachment: 'scroll',
          backgroundColor: '#000'
        }}>
      <div className="relative">
        <FireworkAnimation show={showFireworks} />

        <div className="bg-omoduduwa-indigo/80 backdrop-blur-md text-white py-16">
          <div className="container-custom">
            <motion.h1 
              className="text-4xl md:text-5xl font-bold"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {isLogin ? 'Welcome Back' : 'Join Omo Oduduwa'}
            </motion.h1>
            <motion.p 
              className="text-xl mt-4 text-gray-200"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {isLogin 
                ? 'Sign in to access your account and connect with the community' 
                : 'Complete our enhanced onboarding process to join the movement'}
            </motion.p>
          </div>
        </div>

        <div className="container-custom py-16">
          <motion.div 
            className="max-w-4xl mx-auto bg-white/95 backdrop-blur-sm rounded-lg shadow-xl border border-orange-300/30 overflow-hidden"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <div className="flex">
              <button 
                className={`flex-1 text-center py-4 font-medium text-lg transition-all ${isLogin ? 'bg-omoduduwa-terracotta text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`}
                onClick={() => setIsLogin(true)}
              >
                Sign In
              </button>
              <button 
                className={`flex-1 text-center py-4 font-medium text-lg transition-all ${!isLogin ? 'bg-omoduduwa-terracotta text-white' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`}
                onClick={() => setIsLogin(false)}
              >
                Register
              </button>
            </div>

            <div className="p-8">
              {isLogin ? (
                <LoginForm 
                  onToggleForm={() => setIsLogin(false)}
                />
              ) : (
                <MultiStepRegistrationForm />
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default JoinPage;
